
import React from 'react';
import { Link } from 'react-router-dom';

export const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">About VistaBoost Imaging</h2>
          <p className="text-xl text-gray-600">
            We understand the financial pressures facing Airbnb hosts and property managers. 
            That's why we've developed a cutting-edge, cost-effective solution that transforms your existing photos without the need for expensive reshoots.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/6a90480b0323065f8293a814a770c93a.jpg"
              alt="Luxury Airbnb Property"
              className="rounded-lg shadow-xl w-full h-96 object-cover object-top"
            />
          </div>
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Our Story</h3>
            <p className="text-gray-600 mb-6">
              Founded by a team of photography professionals and AI specialists, VistaBoost Imaging was born from a simple observation: 
              most Airbnb hosts have decent photos that just need professional enhancement to become booking magnets.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-brain-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">
                    <Link to="/blog" className="text-blue-600 hover:text-blue-700 underline">
                      Advanced AI Technology
                    </Link>
                  </h4>
                  <p className="text-gray-600">
                    We use cutting-edge artificial intelligence to enhance and optimize existing photos, 
                    differentiating us from traditional photography services that require expensive reshoots.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-speed-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">
                    <Link to="/pricing-guide" className="text-green-600 hover:text-green-700 underline">
                      Speed & Cost-Effectiveness
                    </Link>
                  </h4>
                  <p className="text-gray-600">
                    Our unique selling proposition combines speed, affordability, and the power of AI to fix common photo issues 
                    without requiring a new photoshoot, saving you time and money.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-trophy-line text-purple-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">Proven Results</h4>
                  <p className="text-gray-600">
                    Our clients typically see a{' '}
                    <Link to="/roi-calculator" className="text-purple-600 hover:text-purple-700 underline font-semibold">
                      40% increase in bookings and 26% higher nightly rates
                    </Link>{' '}
                    after implementing our AI-enhanced photos in their listings.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
